import { render } from "./BackArrowIcon.vue?vue&type=template&id=0b5048c4&bindings={}"
import script from "./BackArrowIcon.vue?vue&type=script&lang=ts"
export * from "./BackArrowIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script